// extracted by mini-css-extract-plugin
module.exports = {"container":"course-btn-back_container__P9Drs","arrow":"course-btn-back_arrow__R8WU4"};